import { AfterViewInit, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { promiseWithCatch } from 'src/app/common/app.helpers';
import { IDeactivate } from 'src/app/common/guards/save-data-guard/save-data.interface';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import ProjectLinks from 'src/app/common/project.links';
import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';
import { CreateItemInfo } from 'src/app/interfaces/views.interface';
import { CreateProjectRequest, Project } from 'src/app/swagger-api';
import { MaybeUndefined } from 'src/app/utils';
import { SocialInitiativeCreation } from '../../shared/social-initiative/social-initiative-creation.abstract';
import { ManageProjectService } from '../manage-project.service';
import { ProjectFormData } from '../projects.interfaces';
@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss'],
})
export class CreateProjectComponent
  extends SocialInitiativeCreation<ProjectFormData>
  implements AfterViewInit, IDeactivate
{
  public redirectUrl: string = ProjectLinks.LINK_PROJECTS;

  private route = inject(ActivatedRoute);
  private manageProjectService = inject(ManageProjectService);
  private operationInfoService = inject(OperationInfoService);

  public readonly formContent$: Observable<FormConstructorContent> = this.manageProjectService.onFormAttrChanges;

  public constructor() {
    super();

    this.fetchAttributeMetadata();
  }

  public ngAfterViewInit(): void {
    this.formValueService.saveFormValue(this.componentForm.childForm.form.value);
    this.subscribeToControlValueChanges();
  }

  public onCancel(): void {
    promiseWithCatch(this.router.navigateByUrl(this.redirectUrl));
  }

  protected fetchAttributeMetadata(): void {
    this.subscriptions$.push(
      this.route.params.subscribe(() => {
        const state: MaybeUndefined<CreateItemInfo<Project>> = this.router.lastSuccessfulNavigation?.extras
          ?.state as CreateItemInfo<Project>;

        if (state) {
          this.manageProjectService.fetchAttributeMetadata(state.data, false, true);
          this.redirectUrl = state.returnUrl || this.redirectUrl;

          return;
        }

        this.manageProjectService.fetchAttributeMetadata();
      }),
    );
  }

  protected changeEntity(data: ProjectFormData): void {
    const _data: CreateProjectRequest = {
      ...data,
      disease_ids: data.diseases,
      specialty_ids: data.specialities,
    } as CreateProjectRequest;

    delete _data['specialities'];
    delete _data['diseases'];

    this.operationInfoService.setupOperation(
      {
        spinner: 'global',
        button: { id: 'btn-manage-project' },
        successfulMessage: 'NEW_PROJECT_CREATED_DESCRIPTION',
      },
      () => {
        this.manageProjectService.createEntity(_data);
      },
    );
  }
}
